import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TextField, CircularProgress, Divider, Chip } from '@mui/material';
import swal from "sweetalert";
import {getInventory, getTransportOrderResponse, searchPendingOrders, removeOrderFromTransport, addOrderToTransport} from "../../utilityFunctions/WarehouseUtil";
import Button from '@mui/material/Button';
import Colors from "../../components/ui/Colors";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useHistory} from "react-router-dom";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    // hour: '2-digit',
    // minute: '2-digit'
};

let allProducts;

export default function TransportOrder(props) {

    const{loginUser, warehouseProducts} = props;

    const history = useHistory();

    const [loading, setLoading] = React.useState(false);
    const [editMode, setEditMode] = React.useState(false);
    const [rawOrders, setRawOrders] = React.useState([]);
    const [addCodeInput, setAddCodeInput] = React.useState("");
    const [searchResults, setSearchResults] = React.useState([]);
    const [editLoading, setEditLoading] = React.useState(false);

    React.useEffect(()=> {

        const handleRenderOrder = async () => {
            await renderOrder();
        }

        handleRenderOrder();
    }, []);

    const initialValues = async () => {
        allProducts = await getInventory(loginUser.jwtToken);

        if(props.location.state && props.location.state.order){
            console.log(props.location.state.order);
            return props.location.state.order;
        }

        return null;
    };


    const convertArray = (originalArray) => {
        
        const result = [];
        
        originalArray.forEach((currentObj) => {
            // console.log(currentObj.orderCode);
            
            const existingGroup = result.find((group) => group.orderCode === currentObj.orderCode);
            
            // console.log(existingGroup);
            
            if (existingGroup) {
                existingGroup.orders.push(currentObj);
            } else {
                result.push({
                    orderCode: currentObj.orderCode,
                    orders: [currentObj],
                });
            }
        });

        // console.log(result);

        return result;

        
    };

    const reduceByItem = (originalArray) => {
        const uniqueItemNumbers = new Set(); // Create a set to store unique itemNumber values
    
        const reducedArray = originalArray.reduce((result, obj) => {
            // Check if the itemNumber is not already in the set
            if (!uniqueItemNumbers.has(obj.itemNumber)) {
                result.push({ itemNumber: obj.itemNumber, description: obj.description });
                uniqueItemNumbers.add(obj.itemNumber); // Add the itemNumber to the set
            }
    
            return result;
        }, []); // Initialize result as an empty array
    
        return reducedArray;
    };

    const reduceByItemPrinting = (originalArray) => {
        const uniqueItemNumbers = new Set(); // Create a set to store unique itemNumber values
        const itemAmounts = {}; // Object to track accumulated amounts by itemNumber

        const reducedArray = originalArray.reduce((result, obj) => {
            // Add to the accumulated amount for this item
            if (itemAmounts[obj.itemNumber]) {
                itemAmounts[obj.itemNumber] += parseFloat(obj.orderAmount || 0);
            } else {
                itemAmounts[obj.itemNumber] = parseFloat(obj.orderAmount || 0);
            }

            // Get bales and barCode for this item
            let bales = 1;
            let barCode = "";
            if (warehouseProducts) {
                const foundProduct = warehouseProducts.find((prod) => prod.itemNumber === obj.itemNumber);
                if (foundProduct) {
                    bales = foundProduct.unitsPerBale;
                    barCode = foundProduct.barCode;
                }
            }

            // Check if the itemNumber is not already in the set
            if (!uniqueItemNumbers.has(obj.itemNumber)) {
                result.push({ 
                    itemNumber: obj.itemNumber, 
                    description: obj.description,
                    productAmount: itemAmounts[obj.itemNumber], // Include the accumulated amount
                    bales: itemAmounts[obj.itemNumber] / bales,
                    barCode: barCode
                });
                uniqueItemNumbers.add(obj.itemNumber); // Add the itemNumber to the set
            } else {
                // Update the amount for existing items
                const existingItem = result.find(item => item.itemNumber === obj.itemNumber);
                if (existingItem) {
                    existingItem.productAmount = itemAmounts[obj.itemNumber];
                    existingItem.bales = itemAmounts[obj.itemNumber] / bales;
                }
            }

            return result;
        }, []); // Initialize result as an empty array

        return reducedArray;
    };



    const sortByString = (arrayOfObjects) => {
        arrayOfObjects.sort((a, b) => {
            const nameA = a.description.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.description.toUpperCase();
          
            if (nameA < nameB) {
              return -1;
            }
          
            if (nameA > nameB) {
              return 1;
            }
          
            return 0; // Names are equal
        });

        return arrayOfObjects;
    };

    const [order, setOrder] = React.useState("");
    
    const renderOrder = async () => {

        setLoading(true);

        const selectedOrder= await initialValues();

        console.log(selectedOrder);

        const ordersArray = selectedOrder.deliveryOrderResponse;

        console.log(ordersArray);

        if(!ordersArray){
            swal({
                title: "Orden incompleta",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        ordersArray.sort((a, b) => a.orderCode - b.orderCode);

        setRawOrders(ordersArray);

        console.log(ordersArray);

        // const productsArray = ordersArray.map((el) => {
        //     return{itemNumber: el.itemNumber, description: el.description}
        // });

        const productsArray = reduceByItem(ordersArray);

        console.log(productsArray);

        sortByString(productsArray);

        console.log(productsArray);

        const accumulatedArray = convertArray(ordersArray);

        console.log(accumulatedArray);

        setOrder(
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{backgroundColor: "silver"}}>
                            <TableCell>
                                <Typography variant="body2">Código</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">Descripción</Typography>
                            </TableCell>
                            {accumulatedArray.map((orderEl) => (
                                <TableCell key={orderEl.orderCode}>
                                    <Typography variant="body2">{orderEl.orderCode}</Typography>
                                </TableCell>
                            ))}
                            <TableCell>
                                <Typography variant="body2">Total Pedido</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">Total Cargado</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2">Diferencia</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {productsArray.map((product) => {
                            let totalAmount = 0;
                            let deliveredAmount = 0;
                            accumulatedArray.forEach((orderEl) => {
                                orderEl.orders.forEach((item) => {
                                    if (item.itemNumber === product.itemNumber) {
                                        totalAmount += parseFloat(item.orderAmount);
                                        if (item.individualsAmount) {
                                            deliveredAmount += parseFloat(item.currentOrderAmount + item.individualsAmount);
                                        } else {
                                            deliveredAmount += parseFloat(item.currentOrderAmount);
                                        }
                                    }
                                });
                            });
                            const diff = totalAmount - deliveredAmount;
                            const rowBg = deliveredAmount >= totalAmount
                                ? "#e8f5e9"
                                : deliveredAmount > 0
                                ? "#fff8e1"
                                : "inherit";

                            return (
                                <TableRow key={product.itemNumber} sx={{backgroundColor: rowBg}}>
                                    <TableCell>
                                        <Typography variant="body2">{product.itemNumber}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{product.description}</Typography>
                                    </TableCell>
                                    {accumulatedArray.map((orderEl) => {
                                        let orderProductAmount = 0;
                                        orderEl.orders.forEach((item) => {
                                            if (item.itemNumber === product.itemNumber) {
                                                orderProductAmount += parseFloat(item.orderAmount);
                                            }
                                        });
                                        return (
                                            <TableCell key={`${product.itemNumber}-${orderEl.orderCode}`}>
                                                <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(orderProductAmount)}</Typography>
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(totalAmount)}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(deliveredAmount)}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" sx={{fontWeight: "bold", color: diff === 0 ? "success.main" : diff > 0 ? "warning.main" : "error.main"}}>
                                            {diff === 0 ? "✓" : new Intl.NumberFormat('es-CO').format(diff)}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        );

        setLoading(false);
    };

    const refreshTransportOrder = async () => {
        const transportId = props.location.state.order.id;
        const updated = await getTransportOrderResponse({id: transportId}, loginUser.jwtToken);
        if (updated) {
            props.location.state.order = updated;
            await renderOrder();
        }
    };

    const handleRemoveOrderCode = async (orderCode) => {
        setEditLoading(true);
        const result = await removeOrderFromTransport({orderCode, transportId: props.location.state.order.id}, loginUser.jwtToken);
        if (result) {
            await refreshTransportOrder();
        }
        setEditLoading(false);
    };

    const handleSearchPending = async () => {
        setEditLoading(true);
        const results = await searchPendingOrders({orderCode: addCodeInput}, loginUser.jwtToken);
        if (results) {
            setSearchResults(convertArray(results));
        }
        setEditLoading(false);
    };

    const handleAddOrderCode = async (orderCode) => {
        setEditLoading(true);
        const result = await addOrderToTransport({orderCode, transportId: props.location.state.order.id}, loginUser.jwtToken);
        if (result) {
            setSearchResults(prev => prev.filter(g => g.orderCode !== orderCode));
            await refreshTransportOrder();
        }
        setEditLoading(false);
    };

    const goToBatches = () => {
        history.push({
            pathname: "/warehouse/transport-order-batches",
            state: {
                order:props.location.state.order,
            }
        });
    }

    const manualPickupSelection = async(selectedProduct) => {
        
        // Use reduce to accumulate orderAmount
        const totalOrderAmount = props.location.state.order.deliveryOrderResponse.reduce((accumulator, currentOrder) => {
            return accumulator + parseFloat(currentOrder.orderAmount);
        }, 0);

        const batchesRequest = {
            order: props.location.state.order,
            description: selectedProduct.description,
            itemNumber: selectedProduct.itemNumber,
            amount: totalOrderAmount
        };

        history.push({
            pathname: "/warehouse/batches-order",
            state: {
                batchesRequest: batchesRequest
            }
        })
    };

    const goToOrdersList = () => {
        history.push({
            pathname: "/warehouse/transport-orders-list",
        });
    }

    const prepareArrayPrinting = () =>{

        setLoading(true);

        const selectedOrder=props?.location?.state && props?.location?.state?.order;

        if(!selectedOrder){
            swal({
                title: "Orden incompleta",
                icon: "error",
                buttons: "OK"
            });
            return;
        };

        console.log(selectedOrder);

        const ordersArray = selectedOrder.deliveryOrderResponse;

        console.log(ordersArray);

        if(!ordersArray){
            swal({
                title: "Orden incompleta",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        ordersArray.sort((a, b) => a.orderCode - b.orderCode);

        console.log(ordersArray);

        // const productsArray = ordersArray.map((el) => {
        //     return{itemNumber: el.itemNumber, description: el.description}
        // });

        const productsArray = reduceByItemPrinting(ordersArray);

        console.log(productsArray);

        setLoading(false);

        return productsArray;
    };

    const handlePrint = (printingType) => {
        const orderPrint = prepareArrayPrinting();

        // Open a new window to print
        const printWindow = window.open('', '_blank');
        
        // Modern approach with structured HTML
        const printDocument = printWindow.document;
        
        printDocument.open();
        
        const html = `
        <html>
            <head>
                <title>Relación Despachos</title>
                <style>
                    @media print { 
                        @page { 
                            size: landscape; 
                            margin: 0.5cm;
                        }
                        body {
                            font-family: 'Arial', sans-serif;
                        }
                    }
                    * {
                        box-sizing: border-box;
                    }
                    body {
                        margin: 0;
                        padding: 0;
                        margin-top: 5%;
                        font-family: 'Arial', sans-serif;
                    }
                    .container { 
                        width: 95%; 
                        margin: auto;
                    }
                    .flex-row { 
                        display: flex; 
                        flex-direction: row; 
                        justify-content: space-between; 
                    }
                    .label-paragraph { 
                        font-size: 18px; 
                        font-weight: bold; 
                        margin: 0 0 20px 0;
                    }
                    .label-paragraph-small { 
                        font-size: 14px; 
                        font-weight: bold; 
                        margin: 0 0 20px 0;
                    }
                    .title-paragraph { 
                        font-size: 22px; 
                        font-weight: bold; 
                        text-align: center; 
                        color: #00674F; 
                        margin: 0 0 20px 0;
                    }
                    .subtitle-paragraph { 
                        font-size: 18px; 
                        font-weight: bold; 
                        text-align: center; 
                        color: #000000; 
                        margin: 0 0 20px 0;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        margin-bottom: 20px;
                        border: 1px solid #000;
                    }
                    th {
                        background-color: #e0e0e0;
                        color: #000000;
                        padding: 10px;
                        text-align: center;
                        font-weight: bold;
                        border: 1px solid #000;
                    }
                    td {
                        padding: 8px;
                        text-align: center;
                        border: 1px solid #000;
                    }
                    .header-section {
                        width: 100%;
                        margin-bottom: 16px;
                        text-align: center;
                    }
                    .client-section {
                        width: 100%;
                        margin-bottom: 16px;
                    }
                    .info-section {
                        margin-bottom: 16px;
                    }
                    .tables-section {
                        margin-bottom: 30px;
                    }
                    .products-table {
                        width: 60%;
                    }
                    .orders-table {
                        width: 35%;
                    }
                    .batches-section {
                        width: 100%;
                        margin-bottom: 30px;
                    }
                    .signatures-section {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 18px;
                    }
                    .signature-line {
                        width: 33.33%;
                        text-align: center;
                    }
                    .signature-text {
                        width: 33.33%;
                        text-align: center;
                    }
                </style>
            </head>
            <body>
                <div class="container">
                    <!-- Header Section -->
                    <div class="header-section">
                        <p class="title-paragraph">RELACIÓN DESPACHOS PRODUCTO TERMINADO</p>
                        <p class="subtitle-paragraph">ALIMENTOS NUTRION S.A.</p>
                    </div>
                    
                    <!-- Client Section -->
                    ${props?.location?.state?.order.deliveryOrderResponse && props?.location?.state?.order.deliveryOrderResponse.length > 0 ? 
                        `<div class="client-section">
                            <p class="label-paragraph-small">Cliente(s): ${Array.from(new Set(props.location.state.order.deliveryOrderResponse.map(order => order.clientName))).join(", ")}</p>
                        </div>` : ''
                    }
                    
                    <!-- Info Section -->
                    <div class="flex-row info-section">
                        <div style="width: 45%;">
                            <p class="label-paragraph">Fecha Despacho: ${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(props?.location?.state?.order.date))}</p>
                            <p class="label-paragraph">Transportadora: ${props?.location?.state?.order.transporter}</p>
                            <p class="label-paragraph">Nombre Conductor: ${props?.location?.state?.order.driverName}</p>
                        </div>
                        <div style="width: 45%;">
                            <p class="label-paragraph">Cédula Conductor: ${props?.location?.state?.order.driverId}</p>
                            <p class="label-paragraph">Placa del vehículo: ${props?.location?.state?.order.carPlate}</p>
                        </div>
                    </div>
                    
                    <!-- Tables Section -->
                    <div class="flex-row tables-section">
                        <div class="products-table">
                            ${buildProductTable(orderPrint)}
                        </div>
                        <div class="orders-table">
                            <p class="subtitle-paragraph">Facturas</p>
                            ${buildOrdersTable(convertArray(props.location.state.order.deliveryOrderResponse))}
                        </div>
                    </div>
                    
                    <!-- Batches Section -->
                    <div class="batches-section">
                        ${printingType === "complete" ? 
                            buildEmptyProductTable(props.location.state.order.deliveryOrderResponse) : 
                            buildEmptyProductTable()
                        }
                    </div>
                    
                    <!-- Comment Section (only for complete printing) -->
                    ${printingType === "complete" && props?.location?.state?.order.comment ? 
                        `<div class="comment-section" style="width: 100%; margin-top: 20px; margin-bottom: 20px;">
                            <p class="label-paragraph" style="text-align: left; margin-bottom: 10px;">Comentarios:</p>
                            <div style="border: 1px solid #000; padding: 15px; min-height: 80px; background-color: #f9f9f9; text-align: left;">
                                <p style="margin: 0; font-size: 14px; white-space: pre-wrap;">${props.location.state.order.comment}</p>
                            </div>
                        </div>` : ''
                    }
                    
                    <!-- Signatures Section -->
                    <div class="signatures-section">
                        <p class="label-paragraph signature-line">__________________</p>
                        <p class="label-paragraph signature-line">__________________</p>
                    </div>
                    
                    <div class="signatures-section" style="margin-bottom: 20px;">
                        <p class="label-paragraph signature-text">Despacho Nutrion</p>
                        <p class="label-paragraph signature-text">Vehículo de Transporte</p>
                    </div>
                </div>
            </body>
        </html>
        `;
        
        printDocument.write(html);
        printDocument.close();
        
        // Wait for resources to load before printing
        printWindow.onload = () => {
            printWindow.print();
            printWindow.close();
        };
    };

    const buildProductTable = (orderPrint) => {
        // Start building the table HTML as a string
        let tableHTML = `
        <table border="1" cellspacing="0" cellpadding="5" style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
            <thead>
                <tr>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; padding: 10px; border: 1px solid #000;">Código</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; padding: 10px; border: 1px solid #000;">Número Item</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; padding: 10px; border: 1px solid #000;">Descripción</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; padding: 10px; border: 1px solid #000;">Cantidad</th>
                </tr>
            </thead>
            <tbody>
        `;

        // Loop through the product batches and add each as a row in the table
        orderPrint.forEach((item) => {
            tableHTML += `
                <tr>
                    <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.barCode}</td>
                    <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.itemNumber}</td>
                    <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.description}</td>
                    <td style="text-align: center; padding: 8px; border: 1px solid #000;">${new Intl.NumberFormat('es-CO').format(item.productAmount)}</td>
                </tr>
            `;
        });

        // Close the table
        tableHTML += `
            </tbody>
        </table>
        `;

        return tableHTML;

    };

    const buildEmptyProductTable = (clientOrders = null) => {
        // Start building the table HTML as a string
        let tableHTML = `
        <table border="1" cellspacing="0" cellpadding="5" style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
            <thead>
                <tr>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 25%; padding: 10px; border: 1px solid #000;">PRODUCTO</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 10%; padding: 10px; border: 1px solid #000;">CANTIDAD</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 10%; padding: 10px; border: 1px solid #000;">LOTE</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 25%; padding: 10px; border: 1px solid #000;">PRODUCTO</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 10%; padding: 10px; border: 1px solid #000;">CANTIDAD</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 10%; padding: 10px; border: 1px solid #000;">LOTE</th>
                    <th style="background-color: #e0e0e0; color: #000000; font-weight: bold; width: 10%; padding: 10px; border: 1px solid #000;">OBSERVACIÓN</th>
                </tr>
            </thead>
            <tbody>
        `;

        if (clientOrders && clientOrders.length > 0) {
            // Extract all batches and individuals from all orders
            const allBatches = [];
            const allIndividuals = [];
            
            clientOrders.forEach(order => {
                // Add product batches
                if (order.productBatchesResponse && order.productBatchesResponse.length > 0) {
                    allBatches.push(...order.productBatchesResponse);
                }
                
                // Add individuals (only those with productAmount > 0)
                if (order.deliveryOrderIndividualsResponse && order.deliveryOrderIndividualsResponse.length > 0) {
                    const filteredIndividuals = order.deliveryOrderIndividualsResponse.filter(individual => 
                        individual.productAmount && parseFloat(individual.productAmount) > 0
                    );
                    allIndividuals.push(...filteredIndividuals);
                }
            });

            // Sort batches by description
            allBatches.sort((a, b) => a.warehouseProduct.description.localeCompare(b.warehouseProduct.description));
            
            // Sort individuals by description if they exist
            if (allIndividuals.length > 0) {
                allIndividuals.sort((a, b) => a.description.localeCompare(b.description));
            }

            // Combine batches and individuals into one array for display (no headers)
            const allItems = [...allBatches, ...allIndividuals];

            // Sort all items by description
            allItems.sort((a, b) => {
                const descA = a.warehouseProduct ? a.warehouseProduct.description : a.description;
                const descB = b.warehouseProduct ? b.warehouseProduct.description : b.description;
                return descA.localeCompare(descB);
            });

            console.log("All items to print:", allItems);

            // Calculate how many rows we need (each row can hold 2 items)
            const totalRows = Math.ceil(allItems.length / 2);
            
            for(let i = 0; i < totalRows; i++) {
                tableHTML += `<tr>`;
                
                // First item in the row (left side)
                if (i * 2 < allItems.length) {
                    const item = allItems[i * 2];
                    const isIndividual = !item.warehouseProduct;
                    
                    tableHTML += `
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${isIndividual ? item.description : (item.warehouseProduct ? item.warehouseProduct.description : '')}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.productAmount ? new Intl.NumberFormat('es-CO').format(item.productAmount) : ''}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.batchCode || ''}</td>
                    `;
                } else {
                    tableHTML += `
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                    `;
                }
                
                // Second item in the row (right side)
                if (i * 2 + 1 < allItems.length) {
                    const item = allItems[i * 2 + 1];
                    const isIndividual = !item.warehouseProduct;
                    
                    tableHTML += `
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${isIndividual ? item.description : (item.warehouseProduct ? item.warehouseProduct.description : '')}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.productAmount ? new Intl.NumberFormat('es-CO').format(item.productAmount) : ''}</td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;">${item.batchCode || ''}</td>
                    `;
                } else {
                    tableHTML += `
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                    `;
                }
                
                // Observation column
                tableHTML += `<td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>`;
                tableHTML += `</tr>`;
            }

            // Fill remaining rows to maintain table size
            const remainingRows = 18 - totalRows;
            for(let i = 0; i < remainingRows; i++) {
                tableHTML += `
                    <tr>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                    </tr>
                `;
            }
        } else {
            // Create 18 empty rows if no orders provided
            for(let i = 0; i < 18; i++) {
                tableHTML += `
                    <tr>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                        <td style="text-align: center; padding: 8px; border: 1px solid #000;"></td>
                    </tr>
                `;
            }
        }

        // Close the table
        tableHTML += `
            </tbody>
        </table>
        `;

        return tableHTML;
    };

    const buildOrdersTable = (deliveryOrders) => {
        // If no delivery orders, return an empty table
        if (!deliveryOrders || deliveryOrders.length === 0) {
            return `
            <table border="1" cellspacing="0" cellpadding="5" style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
                <tbody>
                    <tr><td style="text-align: center; padding: 8px; border: 1px solid #000;"></td></tr>
                </tbody>
            </table>
            `;
        }
        
        // Start building the table HTML as a string
        let tableHTML = `
        <table border="1" cellspacing="0" cellpadding="5" style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
            <thead>
                <tr>
                    <th colspan="${Math.min(deliveryOrders.length, 5)}" style="background-color: #e0e0e0; color: #000000; font-weight: bold; padding: 10px; border: 1px solid #000;">Números de Factura</th>
                </tr>
            </thead>
            <tbody>
        `;

        // Determine the number of columns needed (max 5)
        const columnsPerRow = Math.min(deliveryOrders.length, 5);
        
        // Calculate how many rows we need
        const totalRows = Math.ceil(deliveryOrders.length / columnsPerRow);
        
        // Create rows
        for(let i = 0; i < totalRows; i++) {
            tableHTML += `<tr>`;
            
            // Create cells for this row
            for(let j = 0; j < columnsPerRow; j++) {
                // Calculate the index in the deliveryOrders array
                const orderIndex = i * columnsPerRow + j;
                
                // Check if we have an order code for this cell
                if (orderIndex < deliveryOrders.length) {
                    tableHTML += `
                        <td style="text-align: center; padding: 8px; font-weight: bold; border: 1px solid #000;">${deliveryOrders[orderIndex].orderCode || ''}</td>
                    `;
                }
            }
            
            tableHTML += `</tr>`;
        }

        // Close the table
        tableHTML += `
            </tbody>
        </table>
        `;

        return tableHTML;
    };

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "center"},
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                    overflowY: "scroll",
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> : 
                <Grid container>
                    <Grid item xs={12} sx={{marginTop: "1rem", marginBottom: "2rem"}}>
                        <Grid container alignItems="flex-start">
                            {/* Left: transport info */}
                            <Grid item xs={12} md={7}>
                                <Grid container sx={{textAlign: "start"}}>
                                    <Grid item xs={12} sx={{marginTop: "0.5rem", marginBottom: "1.5rem"}}>
                                        <Typography variant="body1" sx={{color: "black", fontWeight: "bold"}}>Alimentos Nutrion - Documento de Despacho</Typography>
                                    </Grid>
                                    {props.location.state && props.location.state.order &&
                                    <>
                                        {props.location.state.order.deliveryOrderResponse && props.location.state.order.deliveryOrderResponse.length > 0 &&
                                        <>
                                        <Grid item xs={4} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>{"Cliente(s):"}</Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold", fontSize: "12px"}}>
                                                {Array.from(new Set(props.location.state.order.deliveryOrderResponse.map(order => order.clientName))).join(", ")}
                                            </Typography>
                                        </Grid>
                                        </>
                                        }
                                        <Grid item xs={4} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>Destino:</Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>{`${props.location.state.order.destination}`}</Typography>
                                        </Grid>
                                        <Grid item xs={4} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>No de documento:</Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>{`${props.location.state.order.id}`}</Typography>
                                        </Grid>
                                        <Grid item xs={4} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>Fecha:</Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>{`${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(props.location.state.order.date))}`}</Typography>
                                        </Grid>
                                        <Grid item xs={4} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>Placa:</Typography>
                                        </Grid>
                                        <Grid item xs={8} sx={{marginTop: "0.5rem"}}>
                                            <Typography variant="body2" sx={{color: "black", fontWeight: "bold"}}>{`${props.location.state.order.carPlate}`}</Typography>
                                        </Grid>
                                    </>
                                    }
                                </Grid>
                            </Grid>

                            {/* Right: action buttons */}
                            <Grid item xs={12} md={5} sx={{display: "flex", flexDirection: "column", alignItems: {xs: "flex-start", md: "flex-start"}, gap: 1, marginTop: {xs: "1.5rem", md: "0.5rem"}}}>
                                <Button onClick={goToOrdersList} variant="outlined" size="small" sx={{borderColor: Colors.primary, color: Colors.primary, textTransform: "none", minWidth: 180}}>
                                    Atrás
                                </Button>
                                <Button onClick={goToBatches} variant="contained" size="small" sx={{backgroundColor: Colors.primary, textTransform: "none", minWidth: 180}}>
                                    Estibas
                                </Button>
                                <Button onClick={handlePrint} variant="contained" size="small" sx={{backgroundColor: Colors.primary, textTransform: "none", minWidth: 180}}>
                                    Imprimir sin estibas
                                </Button>
                                <Button onClick={() => handlePrint("complete")} variant="contained" size="small" sx={{backgroundColor: Colors.primary, textTransform: "none", minWidth: 180}}>
                                    Imprimir con estibas
                                </Button>
                                <Button onClick={() => { setEditMode(m => !m); setSearchResults([]); setAddCodeInput(""); }} variant="outlined" size="small" sx={{borderColor: Colors.primary, color: Colors.primary, textTransform: "none", minWidth: 180}}>
                                    {editMode ? "Cerrar edición" : "Editar pedidos"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        {order}
                    </Grid>

                    {editMode &&
                    <Grid item xs={12} sx={{marginTop: "1.5rem", marginBottom: "2rem"}}>
                        <Divider sx={{mb: 2}}/>
                        <Typography variant="body1" sx={{fontWeight: "bold", mb: 1}}>Editar pedidos del despacho</Typography>
                        {editLoading ? <CircularProgress size={24}/> :
                        <>
                            <Typography variant="body2" sx={{fontWeight: "bold", mb: 1}}>Pedidos actuales:</Typography>
                            <Box sx={{display: "flex", flexWrap: "wrap", gap: 1, mb: 2}}>
                                {convertArray(rawOrders).map((group) => (
                                    <Chip
                                        key={group.orderCode}
                                        label={group.orderCode}
                                        onDelete={() => handleRemoveOrderCode(group.orderCode)}
                                        color="primary"
                                        variant="outlined"
                                    />
                                ))}
                            </Box>
                            <Divider sx={{mb: 2}}/>
                            <Typography variant="body2" sx={{fontWeight: "bold", mb: 1}}>Agregar pedido:</Typography>
                            <Box sx={{display: "flex", gap: 1, mb: 2, alignItems: "center"}}>
                                <TextField
                                    size="small"
                                    label="Código de pedido"
                                    value={addCodeInput}
                                    onChange={(e) => setAddCodeInput(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === "Enter") handleSearchPending(); }}
                                />
                                <Button onClick={handleSearchPending} variant="outlined" size="small" sx={{borderColor: Colors.primary, color: Colors.primary, textTransform: "none"}}>
                                    Buscar
                                </Button>
                            </Box>
                            {searchResults.length > 0 &&
                            <Box sx={{display: "flex", flexWrap: "wrap", gap: 1}}>
                                {searchResults.map((group) => (
                                    <Chip
                                        key={group.orderCode}
                                        label={group.orderCode}
                                        onClick={() => handleAddOrderCode(group.orderCode)}
                                        color="success"
                                        variant="outlined"
                                        sx={{cursor: "pointer"}}
                                    />
                                ))}
                            </Box>
                            }
                        </>
                        }
                    </Grid>
                    }
                </Grid>
            }
            </Box>
        </Box>
    )
}
